// extracted by mini-css-extract-plugin
export default {"genericHtml":"src-modules-page-blocks-GenericHtml-style__genericHtml_a0CzP"};